module.exports = __webpack_public_path__ + "static/resume-2d021e4656eaa9f8a29bd13ee627780c.png";